import React from "react"
import ReactJWPlayer from "react-jw-player"

const VideoJWPlayer = ({ id }) => {
  return id ? (
    <ReactJWPlayer
      playerId={`jw-player-id-${id}`}
      playerScript="https://content.jwplatform.com/libraries/WUl6F9Vr.js"
      playlist={`https://cdn.jwplayer.com/v2/media/${id}`}
    />
  ) : (
    ""
  )
}

export default VideoJWPlayer
